import React from 'react';
import "../../styles/chats/search_for_user.css";
import { useState, useEffect } from "react";
import { useSearchContext } from "./searchContext";
import { collection, getDocs } from "firebase/firestore";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import UserSearchTab from "./user_search_tab";

import searchIcon from "../../images/chats/search_icon.png";
import profileImage from "../../images/authentication/no_profile.png";

const SearchForUser = ({isSearchShow, setSearchShow}) => {
    const {setIsMessage, setUserId} = useSearchContext();
    const [getIsLoading, setIsLoading] = useState(true);
    const [getSearch, setSearch] = useState("");
    const [getUsersList, setUserList] = useState([]);

    const getAllUsers = async () => {
        try {
            const allUsersRef = collection(firebaseFirestore, 'User Details'); 
            const allUsersSnapshot = await getDocs(allUsersRef);
            allUsersSnapshot.forEach((userDoc) => {
                const userDetails = [
                    userDoc.id,
                    userDoc.data().username,
                    userDoc.data().image ?? "",
                ];

                setUserList(prevList => {
                    const userExists = prevList.some(user => user[0] === userDoc.id);
                    if (userExists) {
                        return prevList;
                    } else {
                        return [...prevList, userDetails];
                    }
                });
            });

            setIsLoading(false);
        } catch (error) {
            console.log(`Error getting all users: ${error.message}`);
            setIsLoading(false);
        }
    };

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const filteredUsers = getUsersList.filter((user) => 
        user[1].toLowerCase().includes(getSearch.toLowerCase())
    );

    const onMessagePressed = () => {
        setSearchShow(false);
    };

    useEffect(() => {
        getAllUsers();
    }, []);

    return(
        <div className={`search_for_user_dialog ${isSearchShow ? "show" : ""}`}>
            <div className="search_for_user_overlay" onClick={() => setSearchShow(false)}></div>
            <div className="search_for_user_content">
                <div className="search_user_input_container">
                    <img alt='search' src={searchIcon} className="search_user_input_icon"/>
                    <input className="search_user_input_field" id="search_user" placeholder="Search for a user" type="text" value={getSearch} onChange={onChangeSearch} />
                </div>

                <div id="search_for_user_column" className="search_for_user_column">
                {filteredUsers.length > 0 ? (
                    filteredUsers.map((user, index) => (
                        <UserSearchTab key={index} setUserImage={user[2] === "" || user[2] === null ? profileImage : user[2]} setUserName={user[1]} id={user[0]} onClose={setSearchShow}  />
                    ))
                ) : (
                    getIsLoading
                    ? <p className="no_users_found">Loading...</p>
                    : getSearch === ""
                    ? <p className="no_users_found">Unable to load users  <span role='img' aria-label="smiling face with tear">🥲</span></p>    
                    : <p className="no_users_found">User "{getSearch}" not found...</p>
                )}
                </div>
            </div>
        </div>
    );
};

export default SearchForUser;